import { Flex, XIcon, SubstackIcon } from '@blockanalitica/ui';
// @ts-ignore
import Logo from '@/assets/logos/BA-logo-full-white.svg?react';
import { ExternalLink } from '@/components';
import { DateTime } from 'luxon';

export default function Footer() {
  const currentYear = DateTime.now().year;
  return (
    <Flex
      as="footer"
      fontSize="-1"
      color="muted"
      padding="0 1"
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      gap="s">
      <Flex gap="2xs">
        <span>© {currentYear}</span>
        <span>|</span>
        <span>Made by</span>
      </Flex>

      <ExternalLink href="https://blockanalitica.com">
        <Logo height={32} />
      </ExternalLink>
      <span>|</span>

      <ExternalLink href="https://x.com/BlockAnalitica" color="muted">
        <XIcon size="0" />
      </ExternalLink>

      <ExternalLink href="https://blockanalitica.substack.com/" color="muted">
        <SubstackIcon size="0" />
      </ExternalLink>

      <div>|</div>

      <ExternalLink
        href="https://blockanalitica.com/terms-of-service/"
        color="muted">
        Terms of Service
      </ExternalLink>
    </Flex>
  );
}
